import React from "react";

function Header(props: any) {
  return <div className="text-nowrap">{props.data}</div>;
}

export default Header;
